import React from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import SharedGPA5to100 from './SharedGPA5to100';
import Shared100toGPA5 from './Shared100toGPA5';
const TITLE = 'Convert Cumulative GPA from 5 to 100 and Vice Versa';
const DESCRIPTION = "Easily convert your cumulative GPA between the 5-point and 100-point systems. Learn how to convert your GPA from 5 to 100 and vice versa using this simple tool.";
const KEYWORDS = "Cumulative GPA Conversion, Convert from 5 to 100, University GPA Conversion, Convert University GPA from 5 to 100, Convert GPA to Percentage";
const OG_URL = 'https://do-calculate.com/calculator/en/grade100to5';
function Grade100to5() {
  return (
    <div className="ltr">
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: '40px' }}>
            <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
          </div>
              <div className="border border-light">
                <div className="row">
                  <div>
                    <p>
                      {DESCRIPTION}
                    </p>
                  </div>
                </div>
                <hr />
                 <MobileUnderCalAds/>
                <div className="row">
                  <div className="col">
                    <Shared100toGPA5 />
                  </div>
                </div>
                <div>
                  <br />
                </div>
                <hr />
                <div className="row">
                  <div className="col">
                    <SharedGPA5to100 />
                  </div>
                </div>
                <div>
                  <br />
                </div>
                <hr />
                <hr />
                <div className="row">
                  <RelatedLinks />
                  <hr />
                </div>
              </div>
        </div>
        <div className="col" >
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={CalculatorsType.studyCalculators}></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: 'auto' }} >
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}  </div>
              <div className="info-section-body">
                <div>
                  <u><h2 style={{ fontSize: '16px' }}>Cumulative GPA Conversion Table from 5 to 100 and Vice Versa</h2>  </u>
                  <table >
                    <tr className='gpa-header'>
                      <th>Grade</th>
                      <th>Point</th>
                      <th>Percentage range</th>
                    </tr>
                    <tr>
                      <td>A+</td>
                      <td>5.0</td>
                      <td>97-100</td>
                    </tr>
                    <tr>
                      <td>A</td>
                      <td>5.0</td>
                      <td>93-96</td>
                    </tr>
                    <tr>
                      <td>A-</td>
                      <td>4.7</td>
                      <td>90-92</td>
                    </tr>
                    <tr>
                      <td>B+</td>
                      <td>4.3</td>
                      <td>87-89</td>
                    </tr>
                    <tr>
                      <td>B</td>
                      <td>4.0</td>
                      <td>83-86</td>
                    </tr>
                    <tr>
                      <td>B-</td>
                      <td>3.7</td>
                      <td>80-82</td>
                    </tr>
                    <tr>
                      <td>C+</td>
                      <td>3.3</td>
                      <td>77-79</td>
                    </tr>
                    <tr>
                      <td>C</td>
                      <td>3.0</td>
                      <td>73-76</td>
                    </tr>
                    <tr>
                      <td>C-</td>
                      <td>2.7</td>
                      <td>70-72</td>
                    </tr>
                    <tr>
                      <td>D+</td>
                      <td>2.3</td>
                      <td>67-69</td>
                    </tr>
                    <tr>
                      <td>D</td>
                      <td>2.0</td>
                      <td>65-66</td>
                    </tr>
                    <tr>
                      <td>F</td>
                      <td>0.0</td>
                      <td>Below 65</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> <br />
    </div>
  );
}
export default Grade100to5;
